import Carousel from "@/src/components/common/carousel";
import HeaderSearch from "@/src/components/common/headerSearch";
import Iconify from "@/src/components/iconify";
import IconCode from "@/src/lib/iconCode";

import { getRandomImage } from "@/src/components/common/common";
import Image from "next/image";
// import ConfirmDialog from "@/src/components/confirm-dialog";
import ConfirmDialog from "@/src/lib/ui/confirmDialog";

import { useCallback, useState } from "react";
import { useSelector } from "react-redux";
// import UploadPriscriptionForm from "./uploadPriscriptionForm";
import { useToast } from "@/src/lib/hooks/useToast";
import { NEXT_IMAGE_CDN } from "@/src/lib/util/config";
import CustomIconButton from "@/src/lib/ui/iconButton";
import useBreakpoint from "@/src/lib/util/custom-hooks/useBreakPoint";
import dynamic from "next/dynamic";

// const images = [
//     "hc-red.webp",
//     "hc-grey.webp",
//     "fever.webp",
//     "experience-care.webp",
// ];

const images = ["hc-grey.webp", "fever.webp"];

const randomImage = getRandomImage(images);

const UploadPriscriptionForm = dynamic(() =>
    import("@/src/modules/home/uploadPriscriptionForm")
);

const HomeSearch = () => {
    const [open, setOpen] = useState(false);
    const isMobile = useBreakpoint("sm");
    const matches = useBreakpoint("md");

    // Function to get the next image in sequence

    const openUplodHandler = useCallback(() => {
        setOpen(true);
    }, []);

    const handleCloseUploadPopup = useCallback(() => {
        setOpen(false);
    }, []);

    return (
        <>
            <div className="h-48 md:h-96 w-full relative aspect-16/9 md:aspect-16/4">
                <Image
                    src={
                        isMobile
                            ? `${NEXT_IMAGE_CDN}/web/home/banner/mobile/${randomImage}`
                            : `${NEXT_IMAGE_CDN}/web/home/banner/desktop/${randomImage}`
                    }
                    alt="Experience Care"
                    fill
                    priority
                    decoding="async"
                    sizes="100vw"
                    className="object-cover object-center"
                />

                <div className="flex justify-center flex-col absolute top-0 left-0 right-0 bottom-0 max-w-340 w-full mx-auto md:flex hidden">
                    <div className="max-w-md w-full md:px-0 px-6">
                        <h1 className="text-center font-normal text-base md:text-4xl leading-0 text-white">
                            Experience Care
                        </h1>

                        <h2 className="text-white md:text-md text-sm font-normal text-center mt-5 md:mb-2 mb-1 text-white">
                            Find Tests, Health Checkups and Centres Near You.
                        </h2>

                        <div className="flex flex-col gap-2 md:gap-2 xs:gap-1.5">
                            <HeaderSearch
                                textFieldClasses={
                                    "rounded-sm bg-white w-full shadow-md relative max-w-md w-full"
                                }
                                buttonFieldClasses={
                                    "bg-primary hover:bg-primary text-white rounded-tr rounded-br rounded-tl-none rounded-bl-none max-w-14 w-full"
                                }
                                inputSize={matches ? "medium" : "small"}
                            />
                            {/*Randhir*/}
                            <p className="text-white md:text-md text-sm font-normal text-center">
                                Can't find your test? Upload Prescription & Get
                                Callback!
                            </p>

                            <div
                                onClick={openUplodHandler}
                                className="md:rounded-lg rounded-md cursor-pointer bg-white md:text-lg text-sm text-black md:max-w-52 py-2 max-w-fit w-full self-center transform-uppercase flex items-center justify-center"
                            >
                                <CustomIconButton
                                    color="primary"
                                    size="small"
                                    className="md:block hidden bg-primary font-medium text-white mr-2 hover:bg-primary hover:text-white"
                                    aria-label="Upload Prescription"
                                >
                                    <Iconify
                                        icon={IconCode.upload}
                                        width={20}
                                        className="text-white"
                                    />
                                </CustomIconButton>
                                <div className="text-base text-black font-medium">
                                    Upload Prescription
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <ConfirmDialog
                open={open}
                onClose={handleCloseUploadPopup}
                title={
                    <h4 className="text-xl font-bold">Upload Prescription</h4>
                }
                content={
                    <UploadPriscriptionForm
                        handleClose={handleCloseUploadPopup}
                    />
                }
                maxWidth="md"
                isCancel={true}
            />
        </>
    );
};

export default HomeSearch;
